import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  AfterViewInit,
  EventEmitter,
  ElementRef,
  NgZone
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { SearchService, SearchResult } from './search.service';
import { GlobalsService } from '../_services/globals.service';
import { EventsService } from '../_services/events.service';
import { LayersService } from '../_services/layers.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  standalone: false
})
export class SearchComponent implements OnInit, AfterViewInit, OnDestroy {
  results: SearchResult[] = [];
  selectedtext: string = '';
  dropdownOpen = false;

  ob_mid: number;
  ob_mids: string;

  srchsubscription: Subscription;
  private layersSub: Subscription;

  @Input() id = '';
  @Output() onselect: EventEmitter<any> = new EventEmitter();

  searchTypes: SelectItem[] = [
    { label: 'Iskanje po naslovu', value: 'address' },
    { label: 'Iskanje po KO ID in ST ID', value: 'ko_id_st_id' }
  ];

  searchType: 'address' | 'ko_id_st_id' = 'address';
  ko_id: number | null = null;
  st_id: number | null = null;

  // poslušalec za klik izven iskalnika (capture faza)
  private outsidePointerDown = (event: Event) => {
    if (!this.dropdownOpen) {
      return;
    }
    if (!this.elRef.nativeElement.contains(event.target as Node)) {
      this.zone.run(() => this.closeDropdown());
    }
  };

  private escapeKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape' && this.dropdownOpen) {
      this.zone.run(() => this.closeDropdown());
    }
  };

  constructor(
    private ss: SearchService,
    private es: EventsService,
    private gs: GlobalsService,
    private ls: LayersService,
    private elRef: ElementRef,
    private zone: NgZone
  ) {}

  ngOnInit(): void {
    this.layersSub = this.ls.subscribeLayersGroupLoadListener().subscribe(
      data => {
        if (data.ob_mid !== undefined) {
          this.cancelSearch();
          this.selectedtext = '';
          this.ko_id = null;
          this.st_id = null;
          this.results = [];
          this.dropdownOpen = false;
          this.ob_mid = data.ob_mid;
          this.ob_mids = data.ob_mids;
        }
      },
      err => console.log(err)
    );
  }

  ngAfterViewInit(): void {
    // izven Angular zone, da vsak klik v aplikaciji ne sproži change detectiona
    this.zone.runOutsideAngular(() => {
      document.addEventListener('pointerdown', this.outsidePointerDown, true);
      document.addEventListener('keydown', this.escapeKeyDown, true);
    });
  }

  ngOnDestroy(): void {
    document.removeEventListener('pointerdown', this.outsidePointerDown, true);
    document.removeEventListener('keydown', this.escapeKeyDown, true);
    this.cancelSearch();
    if (this.layersSub) {
      this.layersSub.unsubscribe();
    }
  }

  private closeDropdown(): void {
    this.dropdownOpen = false;
  }

  private cancelSearch(): void {
    if (this.srchsubscription) {
      this.srchsubscription.unsubscribe();
      this.srchsubscription = null;
    }
  }

  // rezultate pokaži samo, če je uporabnik še vedno v iskalniku
  private openIfFocused(): void {
    this.dropdownOpen =
      this.results.length > 0 &&
      this.elRef.nativeElement.contains(document.activeElement);
  }

  onInputFocus(): void {
    if (this.results.length > 0) {
      this.dropdownOpen = true;
    }
  }

  onSearchTypeChange(): void {
    this.cancelSearch();
    this.results = [];
    this.dropdownOpen = false;
    this.selectedtext = '';
    this.ko_id = null;
    this.st_id = null;
    this.clearSelection();
  }

  onAddressSearch(): void {
    const query = (this.selectedtext || '').trim();

    this.cancelSearch();

    if (query.length < 2) {
      this.results = [];
      this.dropdownOpen = false;
      return;
    }

    this.srchsubscription = this.ss.findAddress(query, 20, this.ob_mid).subscribe(
      res => {
        this.results = res || [];
        this.openIfFocused();
      },
      err => console.log('err:', err)
    );
  }

  onKoIdStIdSearch(): void {
    this.cancelSearch();

    if (this.ko_id == null || this.st_id == null) {
      this.results = [];
      this.dropdownOpen = false;
      return;
    }

    this.srchsubscription = this.ss.findKoIdStId(this.ko_id, this.st_id, 20, this.ob_mid).subscribe(
      res => {
        this.results = res || [];
        this.openIfFocused();
      },
      err => console.log('err:', err)
    );
  }

  onSelect(event: SearchResult): void {
    this.results = [];
    this.dropdownOpen = false;

    if (this.searchType === 'address') {
      this.selectedtext = event.naslov;
    }

    const selected = {
      ...event,
      label: event.naslov,
      id: this.gs.getHsLayerId(),
      caller: this.id
    };

    this.onselect.emit(selected);
    this.ss.setSelectedResult(selected);

    this.es.sendTreeNodeOnOffEvt({
      id: this.gs.getHsLayerId(),
      ison: true
    });
  }

  onEnterPressed(): void {
    if (this.results.length === 1) {
      this.onSelect(this.results[0]);
    }
  }

  onUnSelect(): void {
    this.clearSelection();
  }

  clearSelection(): void {
    this.es.sendTreeNodeOnOffEvt({ id: this.gs.getParceleLayerId(), ison: false });
    this.es.sendTreeNodeOnOffEvt({ id: this.gs.getHsLayerId(), ison: false });
    this.ss.setUnselectResult();
  }

  blockInvalidKeys(event: KeyboardEvent): void {
    if (['e', 'E', '+', '-', '.'].includes(event.key)) {
      event.preventDefault();
    }
  }
}